import React from "react"

import { ComponentWithChildren } from "@cirrus/core/decorators"

import { WithCustomerCssSkins } from "./Skins"
import { SkinsServiceHttp } from "./Skins/service"

export const CustomerSkinsDecorator: ComponentWithChildren = ({ children }) => (
  <WithCustomerCssSkins service={new SkinsServiceHttp()}>
    {children}
  </WithCustomerCssSkins>
)
